import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { TableCustom } from '../../../../components/common';
import {
  DeleteIconButton,
  ViewIconButton,
} from '../../../../components/common/button/CustomIconButton';

const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'NAME',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
  ],
];
interface IProps {
  id: string | null;
  contentType: string;
}

const ViewFile = ({ id, contentType }: IProps) => {
  const [render, setRender] = useState(false);
  const [files, setFiles] = useState<
    { _id: string; name: string; url: string }[] | null
  >(null);
  useEffect(() => {
    axios
      .get(`/api/customerConcernRoutes/${id}`)
      .then((res) => {
        if (res.data) {
          if (contentType === 'image') setFiles(res.data.images);
          else setFiles(res.data.files);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [render]);
  const deleteFile = async (index: number) => {
    if (
      !window.confirm(`Are you sure you want to delete this ${contentType}?`)
    ) {
      return;
    }
    axios
      .delete(
        `/api/customerConcernRoutes/deleteFile/${contentType}/${id}/${index}`,
      )
      .then((res) => {
        if (res.data) {
          alert('document deleted successfully');
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getViewUrl = (fileName: string, fileUrl: string) => {
    if (fileName.includes('.xlsx') || fileName.includes('.xls'))
      return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        fileUrl,
      )}`;
    return fileUrl;
  };
  return (
    <Box sx={{ width: 500 }}>
      <TableCustom tableHeaderObj={Header}>
        {files && (
          <TableBody>
            {files.map((file, index) => (
              <React.Fragment key={file._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{file.name}</TableCell>
                  <TableCell align="center">
                    <>
                      <a
                        target={'_blank'}
                        href={getViewUrl(file.name, file.url)}
                      >
                        <ViewIconButton
                          tooltipTitle="view"
                          sx={{ marginLeft: '1.5rem' }}
                        />
                      </a>
                      <DeleteIconButton
                        tooltipTitle="delete"
                        onClick={() => deleteFile(index)}
                      />
                    </>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      </TableCustom>
    </Box>
  );
};

export default ViewFile;
